import React from 'react'
import Base from './base'
import TextRender from './text'
import RichTextRender from './rich-text'
import MediaRender from './media'
import BooleanRender from './boolean'
import DefaultRender from './default'
import GisRender from './gis'
import OperateRender from './operate'
import UserRender from './user'
import SelectRender from './select'
import RefRender from './ref'
import ProductRender from './product'

const renders = {
  default: DefaultRender,
  text: TextRender,
  richText: RichTextRender,
  media: MediaRender,
  boolean: BooleanRender,
  gis: GisRender,
  operate: OperateRender,
  user: UserRender,
  select: SelectRender,
  ref: RefRender,
  product: ProductRender,
}

const Render = function ({
  value,
  defs,
  rowData,
  rowIndex,
  fields,
  className,
  hooks,
}) {
  return (
    <Base
      value={value}
      defs={defs}
      rowData={rowData}
      rowIndex={rowIndex}
      fields={fields}
      className={className}
      hooks={hooks}
      renders={renders}
    />
  )
}

export default React.memo(Render)
